import { useCallback } from "react";
import { CooperationPage } from "./CooperationPage"
import { useUser } from "../user/UserProvider";

export const IntegratedCooperationPage = () => {
    const gardener = useUser();

    const openAgreementPageInNewTab = useCallback(() => {
        window.open("/agreements/create", "_blank");
    }, []);

    return <CooperationPage gardener={gardener} goToAgreementPage={openAgreementPageInNewTab} />;
};
